import connect from 'react-redux/es/connect/connect';
import { I18n } from 'react-redux-i18n';

import Security from '../components/Security';
import * as userDetailsActions from '../../../actions/UserDetailsActions';
import * as mainActions from '../../../actions';
import { MessageBoxTypes } from '../../../const/ActionsConst';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        userClasses: ownProps.classes,
        commonClasses: state.userDetails.security,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSecurity: () => {
            dispatch(userDetailsActions.getCommonSecurity());
        },
        onDelete: (id) => {
            dispatch(
                mainActions.showMessageBoxBasedOnData(
                    MessageBoxTypes.DELETE_SECURITY_CLASS, 
                    true,
                    I18n.t('Confirm Delete Class'),
                    I18n.t('Are you sure you want to delete the selected class?'), 
                    I18n.t('Delete'),
                    I18n.t('Cancel'), 
                    'small',
                    { id }
                )
            );
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Security);

